import { toast } from "@kyan/ui";

import { IMR_LIQUIDATION_THRESHOLD } from "#/config/settings";
import { usePortfolioToastAction } from "#/hooks/usePortfolioToastActions";
import { useRFQFill } from "#/services/kyan/hooks/useRFQFill";
import { RFQResponseState } from "#/services/kyan/kyan.types";
import { useShowTradeConfirmation } from "#/store/app/portfolio/settings/showTradeConfirmation";
import { usePositionsDrawerMarket } from "#/store/app/positionsDrawer/positionsDrawerMarket";
import { useAccountState } from "#/store/wallet/account/accountState";

import { useRfqRiskData } from "../../../../hooks/useRfqRiskData";

export const useRfqFillButtonController = ({
  response,
  onSuccess,
}: {
  response: RFQResponseState;
  onSuccess?: () => void;
}) => {
  const { market } = usePositionsDrawerMarket();
  const { portfolioState } = useAccountState(market.underlying);
  const { imr } = useRfqRiskData({ response, portfolioState, market });
  const hasSufficientMargin = imr.to <= IMR_LIQUIDATION_THRESHOLD;

  const { showTradeConfirmation } = useShowTradeConfirmation();
  const { getAction } = usePortfolioToastAction();

  const { mutate, isPending } = useRFQFill({
    onSuccess: () => {
      toast.success({
        title: "RFQ fill successful",
        action: getAction({ target: "index", label: "View in Portfolio" }),
      });
      onSuccess?.();
    },
    onError: (error) => {
      toast.error({
        title: "Error with RFQ fill",
        description: error.message,
      });
    },
  });

  const handleFill = () => {
    mutate({
      taker: response.taker,
      response_id: response.responseId,
    });
  };

  return {
    isPending,
    handleFill,
    showTradeConfirmation,
    isDisabled: !hasSufficientMargin,
    tooltip: !hasSufficientMargin ? "Insufficient margin" : undefined,
  };
};
